<template>
  <div class="home" >
   <div class="container p-l-r-0 container-shadow">
    <div class="row">
      <UserProfile></UserProfile>
    </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
            <LeftNav :type="'BS'"/>
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
              <List :type="'BS'"/>
         </div>
    </div>
    <CommonChat/>
</div>
  </div>
</template>

<script>
// @ is an alias to /src
import LeftNav from "../layouts/leftNav.vue"
import CommonChat from "../../components/common_chat.vue"
import List from './list.vue';
import UserProfile from "../layouts/profile-header.vue"

export default {
  name: 'business_setup_index',
  data(){
    return {
      list:{},
      showModal:false,
    }
  },
  components: {
    LeftNav,
    List,
    CommonChat,
    UserProfile
  },
  computed:{
  },
  created(){
    //  this.$store.dispatch('user/fetchUsers')
  }
}
</script>
<style scoped>
.modal-active{
	display:block;
}
</style>
